<template>
    <div class="function-point-block">
        <div class="left-title" v-if="channelWidth>768">
            <div class="line"></div>
            <div class="text">
                <div>{{info.title}}</div>
                <div class="point"></div>
            </div>
            <div class="line"></div>
        </div>
        <div class="right-info">
            <div class="left-img" v-if="info.isLeft">
                <img :src="info.image"/>
            </div>
            <div class="info">
                <div class="info-title">
                    {{info.title}}
                    <img :src="info.icon"/>
                </div>
                <div class="info-content">
                    {{info.info}}
                    <div class="point-list">
                        <div class="info-point" v-for="item in info.pointList">
                            <div class="point"></div>
                            <div>{{item}}</div>
                        </div>
                    </div>

                </div>

            </div>
            <div class="right-img" v-if="!info.isLeft">
                <img :src="info.image"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "function-point-block",
        props:{
            info:Object,
        },
        data(){
            return{
                channelWidth:null
            }
        },
        watch:{
            /**
             * 浏览器宽度变化赋值
             * @param newVal
             */
            '$store.state.screenWidth'(newVal){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if (!this.timer) {
                    // 一旦监听到的productWidth值改变，就将其重新赋给data里的channelWidth.
                    this.channelWidth = newVal
                    this.timer = true;
                    setTimeout(() => {
                        // console.log(this.channelWidth);
                        this.timer = false;
                    }, 400);
                }
            }
        },
        mounted() {
            //获取浏览器宽度
            this.channelWidth = this.$store.state.screenWidth;

        },
    }
</script>

<style lang="scss" src="./function-point-block.scss" scoped>

</style>
